<template>
  <div>
    <home-header></home-header>
    <div class="wrapper pt-3">
      <div class="row">
        <div class="col">
          <div class="bg-white p-3 mb-3">
            <div class="content-box">
              <div class="title">批量查询
              </div>
              <div class="content">
                <div>上传数据，在线查询，导出结果。</div>
                <div>依托3.2亿＋国内企业大数据，一键查询企业工商信息，企业公开联系方式。</div>
              </div>
              <div class="content pt-1 pb-1">
                <el-button icon="el-icon-upload2" type="primary" size="" @click="dlg_add_pkg=true">上传数据</el-button>
                <el-button icon="el-icon-delete" type="primary" size="" @click="batchRemove">删除</el-button>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="bg-white">
            <div class="p-3">
              <div class="search_list">
                <div>
                  <div style="float:left"></div>
                  <div style="float:right" class="cursor-pointer p-2" @click="getFolderList"><i
                      class="el-icon-refresh">刷新</i>
                  </div>
                </div>
                <el-pagination layout="total, prev, pager, next" @current-change="panel_pagechange"
                               :page-size="this.panel_page.size" :total="this.panel_page.total"
                               :current-page="this.panel_page.index+1">
                </el-pagination>
                <el-table :data="folderList" stripe border highlight-current v-loading="listLoading"
                          style="min-height: 520px;" @selection-change="selsChange">
                  <el-table-column type="selection" width="50px"></el-table-column>
                  <el-table-column label="名称" width="200">
                    <template slot-scope="scope">
                      <el-button @click="groupChange(scope.row)" type="text">{{ scope.row.name }}
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column property="remark" label="简介"></el-table-column>
                  <el-table-column label="数量" width="110">
                    <template slot-scope="scope">
                      <a v-if="scope.row.type=='ent'">
                        {{ scope.row.entCount }}
                      </a>
                      <a v-if="scope.row.type=='upload'">
                        {{ scope.row.entCount }}
                      </a>
                      <a v-if="scope.row.type=='udb'">
                        {{ scope.row.humCount }}
                      </a>
                      <a v-if="scope.row.type=='staff'">
                        {{ scope.row.humCount }}
                      </a>
                    </template>
                  </el-table-column>

                  <el-table-column label="添加时间" width="110">
                    <template slot-scope="scope">
                      {{ scope.row.addtime | formatDateTime }}
                    </template>
                  </el-table-column>
                  <el-table-column label="状态" width="120">
                    <template slot-scope="scope">
                      <div v-if="scope.row.status==1"><i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;数据处理中
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="查看" width="70">
                    <template slot-scope="scope">
                      <a class="fa fa-download" :href="apiUrl+scope.row.entFile" target='_blank'>&nbsp;下载
                      </a>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                      <el-button @click="update_status(scope.row)" type="text">重新处理</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination layout=" prev, pager, next" @current-change="panel_pagechange"
                               :page-size="this.panel_page.size" :total="this.panel_page.total"
                               :current-page="this.panel_page.index+1">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>


      <el-drawer title="详细信息" :visible.sync="dlg_pkg_detail" :close-on-click-modal="true"
                 size="600px">
        <div class="col-right">
          <div class="pr-4 pl-4">
            <div v-if="this.page.total>0" class="content-box">
              <div v-if="this.sltItem.status==1" class="title"><i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;数据处理中
              </div>
              <div v-else class="title">{{ this.sltItem.name }}
                <el-button size="mini" class="ml-2" @click="update_status(index,item)">重新处理</el-button>
              </div>
              <div v-if="this.sltItem.humCount>0" class="content">
                <label v-if="this.sltItem.entCount>0"
                       style="width:350px;">企业列表（含公开联系方式）：{{ this.sltItem.entCount }}家 &nbsp;
                  <el-link :disabled="this.sltItem.entFile==null || this.sltItem.entFile.length<20"
                           :href="this.apiUrl+this.sltItem.entFile" target='_blank'>免费下载
                  </el-link>
                </label>
                <label v-if="this.sltItem.humCount>0" style="width:350px;">法人、高管和股东：{{
                    this.sltItem.humCount
                  }}人
                  &nbsp;
                  <el-link :href="this.apiUrl+this.sltItem.txtFile">下载
                  </el-link>
                </label>
              </div>
              <div v-if="this.sltItem.humCount>0" class="content">
                <label style="width:350px;">MD5数据包（广告投放）：{{ this.sltItem.md5Count }}条 &nbsp;
                  <el-link :disabled="this.sltItem.md5File==null || this.sltItem.md5File.length<20"
                           :href="this.apiUrl+this.sltItem.md5File" target='_blank'>下载
                  </el-link>
                </label>
              </div>
            </div>
          </div>
          <div class="">
            <div class="pl-3">
              <div v-if="listLoading" class="item">
                <div class="h-420">
                  <div class="loading_position">
                    <i class="el-icon-loading" style="font-size: 25px;margin-left: 10px;margin-bottom: 10px;"></i>
                    <span class="d-block">加载中...</span>
                  </div>
                </div>
              </div>
              <div v-else-if="dataList==null || dataList.length == 0">
                <div class="h-435">
                  <div class="loading_position">
                    <span class="d-block"></span>
                  </div>
                </div>
              </div>
              <div v-else class="main_content">
                <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
                               :page-size="this.page.size" :total="this.page.total" :current-page="this.page.index+1">
                </el-pagination>
                <div v-for="(item,index) in dataList" class="item pr-3 pb-2">
                  <el-card shadow="always" style="height:auto;">
                    <div class="content-box" style="">
                      <div v-if="item.company_name">
                        <div class="title">
                          <span>{{ item.company_name }}</span>
                        </div>
                        <div v-if="item.legal_person" class="content">
                          <label>法人：{{ item.legal_person }}
                            <a @click="getHumDetail(item)"> (更多高管)</a></label>
                        </div>
                        <div v-if="item.reg_capital" class="content">
                          <label>注册资金：{{ item.reg_capital }}</label>
                        </div>
                        <div v-if="item.reg_date" class="content">
                          <label>成立时间：{{ item.reg_date|formatDateTime }}</label>
                        </div>
                        <div v-if="item.address" class="content">
                          <label>地址：{{ item.address }}</label>
                        </div>
                      </div>
                      <div v-else>
                        <div class="title">
                          <span style="cursor: pointer" @click="getInfoDetail(item)">{{ item.name }}</span>
                        </div>
                        <div v-if="item.gender" class="content">
                          <label v-if="item.gender=='female'">性别：女</label>
                          <label v-else-if="item.gender=='male'">性别：男</label>
                        </div>
                        <div v-if="item.birthDay" class="content">
                          <label>出生日期：{{ item.birthDay }}</label>
                        </div>
                        <div v-if="item.adMd5" class="content">
                          <label>投放ID：<a @click="getHumDetail(item)">{{ item.adMd5 }}</a></label>
                        </div>
                        <div v-if="item.phone" class="content">
                          <label>电话：{{ item.phone }}</label>
                        </div>
                        <div v-if="item.adMd5Dec" class="content">
                          <label>电话：{{ item.adMd5Dec }}</label>
                        </div>
                        <div v-if="item.mobileProv" class="content">
                          <label>地区：{{ item.mobileProv }},{{ item.mobileCity }}</label>
                        </div>
                        <div v-if="item.companyName" class="content">
                          <label>公司：<span> {{ item.companyName }}</span></label>
                        </div>
                        <div v-if="item.typeJoin" class="content">
                          <label>职位：<span v-for="(i,v) in item.typeJoin">
                          {{ i.trim() }}
                        </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </el-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>

      <el-drawer title="高管列表" :visible.sync="dlg_ent_hum_detail" size="500px">
        <div v-if="humlistLoading==false">
          <div v-if="ent_hum_list.length==0" class="h-420">
            <div class="loading_position" style="padding-top: 150px;">
              <span class="d-block">无数据</span>
            </div>
          </div>
          <div v-else>
            <h1 class="p-3" style='font-size: 18px;'>{{
                dlg_hum_detail_title + "（" + ent_hum_list.length + "）人"
              }}
            </h1>
          </div>
          <div v-for="(item,index) in ent_hum_list" class="pl-3 pb-3 pr-3">
            <el-card shadow="always" style="height:auto;">
              <div class="content-box" style="">
                <div class="title">
                  <span style="cursor: pointer" @click="getInfoDetail(item)">{{ item.name }}</span>
                </div>
                <div v-if="item.gender" class="content">
                  <label v-if="item.gender=='female'">性别：女</label>
                  <label v-else-if="item.gender=='male'">性别：男</label>
                </div>
                <div v-if="item.birthDay" class="content">
                  <label>出生日期：{{ item.birthDay }}</label>
                </div>
                <div v-if="item.phone" class="content">
                  <label style="cursor: pointer" @click="getPhoneNumber(item)">电话：{{ item.phone }}</label>
                </div>
                <div v-for="(phone,idx) in item.udb_list" class="content">
                  <label>电话：{{ phone }}</label>
                </div>
                <div v-if="item.typeJoin" class="content">
                  <label>职位：<span v-for="(i,v) in item.typeJoin">{{ i.trim() }}
                        </span>
                  </label>
                </div>
                <div v-if="item.share">
                  <div>股份：{{ item.share }}</div>
                </div>
              </div>
            </el-card>
          </div>
        </div>
        <div v-else>
          <div class="h-420">
            <div class="loading_position" style="padding-top: 150px;">
              <i class="el-icon-loading" style="font-size: 25px;margin-left: 10px;margin-bottom: 10px;"></i>
              <span class="d-block">{{ loading_info }}</span>
            </div>
          </div>
        </div>
      </el-drawer>

      <el-dialog title="申请使用" :visible.sync="dlg_share" :close-on-click-modal="true"
                 width="720px">
        <el-form ref="form" :model="form" label-width="100px" class="pr-4">
          <el-form-item label="数据简介">
            <div>
              数据包主要由上市公司高管，专精特新企业高管等人员组成，数据范围是全国，可依据业务需要对地域，年龄，性别等属性做进一步筛选
            </div>
          </el-form-item>

          <el-form-item class="mobile-hidden" label="出生日期">
            <el-date-picker v-model="form.date_range" type="monthrange" align="left" class="item_w"
                            unlink-panels range-separator="——" start-placeholder="开始" end-placeholder="结束"
                            :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>

          <el-form-item class="mobile-hidden " label="地区">
            <el-select v-model="form.mobileProv" clearable placeholder="请选择" class="item_w"
                       v-on:change="getProv($event,'city')">
              <el-option v-for="item in provs" :key="item.value" :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <label class="item_label">城市</label>
            <el-select v-model="form.adCity" placeholder="请选择城市" class="item_w">
              <el-option v-for="item in citys" :key="item.value" :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="性别">
            <el-radio v-model="form.gender" label="male">男性</el-radio>
            <el-radio v-model="form.gender" label="female">女性</el-radio>
            <el-radio v-model="form.gender" label="">不限</el-radio>
          </el-form-item>

          <el-form-item label="授权时间">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" class="item_w"></el-date-picker>
            <label class="item_label">时间</label>
            <el-time-picker placeholder="选择时间" v-model="form.date2" class="item_w"></el-time-picker>
          </el-form-item>
          <el-form-item label="即时推送">
            <el-switch v-model="form.delivery"></el-switch>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="form.desc" style="width:529px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary">立即提交</el-button>
            <el-button @click.native="dlg_share=false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog title="上传数据" :visible.sync="dlg_add_pkg" width="650px" :close-on-press-escape="false"
                 :close-on-click-modal="false">

        <div class="pl-5 mb-3">
          1、下载<a style="margin-left: 5px;margin-right:5px" href="/static/files/sample.xlsx"
                   download="样例文件">文件模板</a>请根据模版的文件格式填写你要批量导入的资源
        </div>
        <div class="pl-5 mb-3">
          2、上传文件导入资源
        </div>
        <el-upload class="pl-5" drag multiple ref="upload" :action="getActionUrl()" :headers="myHeaders"
                   :auto-upload="false" :data="uploadData"
                   :before-upload="beforeAvatarUpload" :on-success="uploadSuccess" :on-error="uploadError">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text mb-3">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip">
            <div class="mb-3 mt-3">支持数据类型：.txt格式的文件</div>
            <div class="mb-3">可以上传多个文件，单个文件大小不能超过 100MB</div>
          </div>
        </el-upload>
        <div class="pl-5 mt-3 mb-3">
          <el-button type="primary" @click="submitUpload">上传到服务器
          </el-button>
          <el-button class="mr-2" type="primary" @click="dlg_add_pkg=false">取消
          </el-button>
        </div>
      </el-dialog>

      <el-dialog title="修改数据包" :visible.sync="dlg_export_model" :close-on-click-modal="false"
                 width="500px">
        <el-form ref="form" :model="form" label-width="80px" class="pr-3">
          <el-form-item label="文件夹名">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="有效时间">
            <el-col :span="11">
              <el-date-picker type="date" placeholder="选择日期" v-model="form.date1"
                              style="width: 100%;"></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-time-picker placeholder="选择时间" v-model="form.date2" style="width: 100%;"></el-time-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="发送邮件">
            <el-switch v-model="form.delivery"></el-switch>
          </el-form-item>
          <el-form-item v-if="form.delivery" label="邮件地址">
            <el-input v-model="form.reciveEmail"></el-input>
          </el-form-item>
          <el-form-item label="导出内容">
            <el-checkbox-group v-model="form.type">
              <el-checkbox label="工商信息" name="type" style="width:140px;"></el-checkbox>
              <el-checkbox label="法人/股东/高管" name="type"></el-checkbox>
              <el-checkbox label="MD5广告投放数据包" name="type" style="width:140px;"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="特殊资源">
            <el-radio-group v-model="form.resource">
              <el-radio label="外呼系统支持"></el-radio>
              <el-radio label="短信支持"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="数据描述">
            <el-input type="textarea" v-model="form.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="btn_saveData">保存</el-button>
            <el-button @click="dlg_export_model=false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <home-footer></home-footer>
  </div>
</template>

<script>
import api from "../../api/rest";
import util from "../../api/util";
import EntList from "../../components/EntList";
import HomeHeader from "../../components/HomeHeader.vue";
import HomeFooter from "../../components/HomeFooter.vue";

export default {
  components: {HomeFooter, HomeHeader, EntList},
  data() {
    return {
      apiUrl: api.profile.getApiUrl(),
      menuTitle: "私有人群包",
      dlg_hum_detail_title: "",
      loading_info: "",
      provs: util.setting.getProvs_slim(),
      prov_sime: true,
      pickerOptions: util.setting.getPickeAgeOpt(),
      menuLoading: false,
      dlg_export_model: false,
      dlg_ent_hum_detail: false,
      dlg_add_pkg: false,
      form: {
        addType: 0,
        fldId: '',
        name: '',
        size: 1000,
      },
      folderList: [],
      ent_hum_list: [],
      page: {
        total: 0,
        index: 0,
        size: 5,
      },
      panel_page: {
        size: 20,
        total: 0,
        index: 0
      },
      uploadData: {
        name: '',
        count: 0,
        addType: 0,
        fldId: ''
      },
      dlg_pkg_detail: false,
      dlg_share: false,
      scope: 'all',
      citys: [],
      sltItem: {},
      ent_item: {},
      dataList: [],
      indusList: util.setting.getIndustry(),
      myHeaders: api.profile.getHeaders(),
      humlistLoading: false,
      listLoading: false,
      dlg_loading: false,
      collapse: api.storage.get('isCollapse'),
    }
  },
  methods: {
    btn_cancel() {
      this.form = {
        provinces: [],
        query: "",
        date_range: [],
        date_field: "birthDay",
        tags: [],
        query_field: "name",
      }
    },
    groupChange(item, index) {
      // this.isActive = index
      this.form.tags = []
      let para = {}
      para.id = item.id
      let api_url = "/folder/get"
      api.remote.doPost(para, api_url).then((res) => {
        this.sltItem = res
        this.form.tags.push(this.sltItem.value)
        this.search_action()
        this.dlg_pkg_detail = true;
        // this.search_action()
      }).catch((res) => {
        this.addLoading = false
        api.handError.action(this, res)
      })
    },
    // upload file
    getActionUrl() {
      return (
          api.profile.getApiUrl() +
          "/folder/upload"
      );
    },
    uploadSuccess() {
      this.getFolderList();
      this.$message({
        message: "上传成功，请查看！",
        type: "success",
      });
      this.dlg_add_pkg = false;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    uploadError(response, file, fileList) {
      this.$message({
        message: "上传失败，请重试！",
        type: "warning",
      });
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      var substr = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = substr === "xls";
      const extension2 = substr === "xlsx";
      const extension3 = substr === "csv";
      const extension4 = substr === "txt";
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!extension4) {
        this.$message({
          message: "文件格式错误，请上传.txt格式的文件",
          type: "warning",
        });
      }
      if (!isLt2M) {
        this.$message({
          message: "文件大小错误，请上传小于100MB的文件",
          type: "warning",
        });
      }
      return extension4 && isLt2M;
    },
    item_change(item) {
      this.$confirm("确定将该人群包设置成公共人群包", "提示", {
        type: "warning",
      }).then(() => {
        let para = item
        let api_url = "/folder/change"
        api.remote.doPost(para, api_url).then((res) => {
          this.$message({
            title: res.title,
            message: res.message,
            type: res.status
          })
          this.getFolderList()
        }).catch((res) => {
          this.addLoading = false
          api.handError.action(this, res)
        })
      })
    },

    // 批量删除
    batchRemove() {
      var models = this.sels.map(item => item)
      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        let para = models
        let api_url = "/folder/delete"
        api.remote.doPost(para, api_url).then((res) => {
          this.listLoading = false
          this.$message({
            title: res.title,
            message: res.message,
            type: res.status
          })
          this.getFolderList()
        })
      }).catch((res) => {
        api.handError.action(this, res)
      })
    },
    selsChange(sels) {
      this.sels = sels
    },

    item_delete(item) {
      this.$confirm("删除选中的记录将不可恢复", "提示", {
        type: "warning",
      }).then(() => {
        let para = [item]
        let api_url = "/folder/delete"
        api.remote.doPost(para, api_url).then((res) => {
          this.$message({
            title: res.title,
            message: res.message,
            type: res.status
          })
          this.getFolderList()
        }).catch((res) => {
          this.addLoading = false
          api.handError.action(this, res)
        })
      })
    },

    panel_pagechange(val) {
      this.panel_page.index = val - 1;
      this.getFolderList()
    },
    edit_data(item) {
      this.form = item
      this.dlg_export_model = true;
    },
    btn_saveData() {
      let api_url = "/folder/add"
      let para = {
        ...this.form
      }
      api.remote.doPost(para, api_url).then((res) => {
        this.$message({
          title: res.title,
          message: res.message
        })
        this.dlg_export_model = false;
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    search_action() {
      this.page.size = this.page.size;
      let api_url = "/search/rawQuery"
      let para = {
        ...this.form,
        ...this.page
      }
      para.id = this.sltItem.id
      api.remote.doPost(para, api_url).then((res) => {
        this.dataList = res.content;
        this.page.total = res.totalElements
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    btn_run_query(val) {
      this.page.index = 0;
      this.search_action();
    },
    show_more() {
      if (this.prov_sime == true) {
        this.provs = util.setting.getProvs()
        this.prov_sime = false
      } else {
        this.provs = util.setting.getProvs_slim()
        this.prov_sime = true
      }
    },
    update_status(item) {
      let api_url = '/folder/updateStatus'
      let param = item
      param.status = 1
      api.remote.doPost(param, api_url).then((res) => {
        this.$message({
          title: res.title,
          message: res.message,
          type: "warning"
        })
      }).catch((res) => {
        api.handError.action(this, res);
      })
    },
    getHumDetail(row) {
      let postData = {
        index: 0,
        size: 100,
      }
      if (row.uni_code == null) {
        postData['cid'] = row.cid
      } else {
        postData['uni_code'] = row.uni_code
      }
      let api_url = '/slice/humQuery'
      this.loading_info = '加载中...'
      this.dlg_hum_detail_title = row.company_name
      this.dlg_ent_hum_detail = true
      this.humlistLoading = true
      this.ent_hum_list = []
      api.remote.doPost(postData, api_url).then((res) => {
        // 排序
        res.content.sort(function (a, b) {
          function getScore(a) {
            if (a.typeJoin == null) {
              if (a.name == null || a.name == "未知") {
                return 0.0
              } else {
                return 45.0
              }
            }

            let score_a = 0.0
            if (a.typeJoin.some(element => element.includes("副董事长"))) {
              score_a += 40.0
            } else if (a.typeJoin.some(element => element.includes("董事长"))) {
              score_a += 50.0
            } else if (a.typeJoin.some(element => element.includes("董事会"))) {
              score_a += 50.0
            } else if (a.typeJoin.some(element => element.includes("总"))) {
              score_a += 40.0
            } else if (a.typeJoin.some(element => element.includes("经理"))) {
              score_a += 35.0
            } else if (a.typeJoin.some(element => element.includes("法人"))) {
              score_a += 35.0
            } else if (a.typeJoin.some(element => element.includes("负责人"))) {
              score_a += 35.0
            } else if (a.typeJoin.some(element => element.includes("股东"))) {
              score_a += 30.0
            } else if (a.typeJoin.some(element => element.includes("独立董事"))) {
              score_a += 9
            } else if (a.typeJoin.some(element => element.includes("董事"))) {
              score_a += 10.0
            } else if (a.typeJoin.some(element => element.includes("监事会主席"))) {
              score_a += 8.0
            } else if (a.typeJoin.some(element => element.includes("监事长"))) {
              score_a += 5.0
            } else if (a.typeJoin.some(element => element.includes("监事"))) {
              score_a += 0.0
            }
            return score_a
          }

          let score_a = getScore(a)
          let score_b = getScore(b)

          if (a.share != null) {
            score_a += parseFloat(a.share.replace("%", ""))
          }
          if (b.share != null) {
            score_b += parseFloat(b.share.replace("%", ""))
          }
          return score_b - score_a
        });
        this.humlistLoading = false
        this.ent_hum_list = res.content

      }).catch((res) => {
        this.dlg_ent_hum_detail = false
        this.humlistLoading = false
        api.handError.action(this, res);
      });
    },
    handleCurrentChange(val) {
      this.page.index = val - 1;
      this.search_action();
    },
    radio_change() {
      this.panel_page = {
        size: 20,
        total: 0,
        index: 0
      }
      this.getFolderList()
    },
    getFolderList() {
      let para = {
        ...this.panel_page
      }
      para.type = "upload"
      let api_url = '/folder/list'
      this.listLoading = true;
      api.remote.doPost(para, api_url).then((res) => {
        this.folderList = res.content;
        this.panel_page.total = res.totalElements
        this.listLoading = false;
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });
    }
  },
  filters: {
    formatMoney(num) {
      num = num / 10000
      return num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      }) + "万";
    },
    formatDateTime(time) {
      var date = new Date(time)
      return date.format("yyyy-MM-dd")
    }
  },
  mounted() {
    this.getFolderList()
    // this.search_action()
  }
}
</script>


// WEBPACK FOOTER //
// Insight.vue?3907dafc